export default __webpack_public_path__ + "static/media/gift@3x.9f914bd7.png";